<template>
    <div>
        <h1>Admin Client</h1>

		<div>Activer l'interface de validation <b-checkbox style="display:inline-block" v-model="client.details.validation" /></div>
		<div>Activer le partage d'éléments <b-checkbox style="display:inline-block" v-model="client.details.share_get" /></div>

		<h2>Utilisation des clés api SMD</h2>

		<div>ChatGPT <b-checkbox style="display:inline-block" v-model="credentials.chatgpt_key" /></div>
		<div>Perplexity <b-checkbox style="display:inline-block" v-model="credentials.perplexity_key" /></div>
		<div>SerpApi <b-checkbox style="display:inline-block" v-model="credentials.serpapi_key" /></div>

		<br />

		<b-button @click="save"><i class="fas fa-save"></i></b-button>
    </div>

</template>

<script>
	import store from "../store.js";

	import service_clients from "../services/client.js";
	import users from "../services/users.js";

	export default {
		name: "admin_credits",
        components: {
        },
		data: function () {
			return {
				client: {
					details: {}
				},
				credentials: {
					chatgpt_key: false,
					perplexity_key: false,
					serpapi_key: false
				},
			};
		},
		methods: {
            isAdmin: function() {
                return store.getters.isAdmin;
			},
			save()
			{
				this.client.details.credentials = null;

				if (this.credentials.chatgpt_key)
				{
					if (!this.client.details.credentials)
						this.client.details.credentials = {};
					if (!this.client.details.credentials.chatgpt)
						this.client.details.credentials.chatgpt = {};
					this.client.details.credentials.chatgpt.chatgpt_key = true
				}
				if (this.credentials.perplexity_key)
				{
					if (!this.client.details.credentials)
						this.client.details.credentials = {};
					if (!this.client.details.credentials.chatgpt)
						this.client.details.credentials.chatgpt = {};
					this.client.details.credentials.chatgpt.perplexity_key = true
				}
				if (this.credentials.serpapi_key)
				{
					if (!this.client.details.credentials)
						this.client.details.credentials = {};
					if (!this.client.details.credentials.api)
						this.client.details.credentials.api = {};
					this.client.details.credentials.api.serpapi_key = true
				}

				service_clients.put_admin(this.client)

				store.commit("setClient", this.client);

				this.$notify({
					group: "info",
					title: "Configuration enregistrée",
					type: "success",
				});
			}
		},
		mounted: async function () {
			
			if (!this.isAdmin())
			{
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;
			
			if (this.client.details.credentials)
			{
				if (this.client.details.credentials.chatgpt && this.client.details.credentials.chatgpt.chatgpt_key)
					this.credentials.chatgpt_key = true;
				if (this.client.details.credentials.chatgpt && this.client.details.credentials.chatgpt.perplexity_key)
					this.credentials.perplexity_key = true;
				if (this.client.details.credentials.api && this.client.details.credentials.api.serpapi_key)
					this.credentials.serpapi_key = true;
			}
		},
	};
</script>
